export default "__VITE_ASSET__CdSEApIw__"